import { createColorsContext } from './colors-context-factory';

const { ColorsContext, useColorsContext } = createColorsContext('RunSetsColorsContextProvider');

export const RunSetsColorsContext = ColorsContext;
export const useRunSetsColorsContext = useColorsContext;
